import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import ImageLoader from "../ImageLoader/ImageLoader";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const handleWhatsApp = (product) => {
    const message = `Ola, Estou interresado no ${product.name} por ${product.stock.price}$00. Pode dizer mais sobre este produto?`;
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${config.Number_Whatsapp}?text=${encodedMessage}`,
      "_blank"
    );
  };

  const handleViewDetails = (productId) => {
    navigate(`/product/${productId}`);
    localStorage.setItem("scroll-position", window.scrollY)
    localStorage.setItem("datetime-scroll-position", (new Date()).getTime())
    // In a real app, this would navigate to the product detail page
  };
  return (
    <div>
      {product.stock &&
        (
          <div
            key={product.id}
            className="product-card"
            onClick={() => handleViewDetails(product.id)}
          >
            <ImageLoader src={product.image_url} className={"product-image"} />

            <div className="product-info">
              <h3 className="product-title">{product.name}</h3>
              <div className="product-price">{product.stock.price}$00</div>
              <p className="product-description">{product.description}</p>

              <div className="stock-info">
                {product.stock.quant_available > 0 ? (
                  <span className="in-stock">
                    <i className="fas fa-check-circle"></i> No Stock
                  </span>
                ) : (
                  <span className="out-of-stock">
                    <i className="fas fa-times-circle"></i> Sem Stock
                  </span>
                )}
              </div>

              <div className="product-actions">
                <button
                  className="view-details-btn"
                  onClick={() => handleViewDetails(product.id)}
                >
                  <i className="fas fa-eye"></i> Detalhes
                </button>
                <button
                  className="whatsapp-btn"
                  onClick={() => handleWhatsApp(product)}
                >
                  <i className="fab fa-whatsapp"></i> Envia messagem via WhatsApp
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default ProductCard;
